// extracted by mini-css-extract-plugin
export default {"mt":"PrivacyPolicyView_mt__x5u51"};